<template>
  <div class="pega-preview">
    <message-create-accordion-button>
      <p
        class="margin-0 boss-text"
        data-test="notification-target-text"
      >
        ※下記の対象者に通知されます。<br>
        &emsp;・企業担当者（BOSS-Cアカウント）<br>
        &emsp;・営業担当者（BOSS-Sで設定されている営業担当者と代理店アカウント）
      </p>
      <message-input
        :value="value"
        :is-over-length="isOverLength"
        :max="maxMessageBody"
        :disabled="isMessageInputDisabled"
        @input="$emit('input', $event)"
      />
    </message-create-accordion-button>
    <div
      v-if="!hasApprovalPermission"
      class="pega-notice text-center"
      data-test="notice"
    >
      ※このアカウントでは承認作業は行えません。
    </div>
    <div class="boss-button-container">
      <div>
        <button
          :disabled="isRejectButtonDisabled"
          class="boss-button boss-button-confirm pega-button"
          data-test="button-reject"
          @click="$emit('reject')"
        >
          不承認（メッセージを送信する）
        </button>
      </div>
      <div>
        <button
          :disabled="isApproveButtonDisabled"
          class="boss-button boss-button-confirm pega-button"
          data-test="button-approve"
          @click="$emit('approve')"
        >
          承認
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MessageCreateAccordionButton from '@/components/atoms/MessageCreateAccordionButton'
import MessageInput from '@/components/atoms/MessageInput'

export default {
  components: {
    MessageCreateAccordionButton,
    MessageInput
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isOverLength: {
      type: Boolean,
      default: false
    },
    maxMessageBody: {
      type: Number,
      default: 2000
    },
    hasApprovalPermission: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isMessageInputDisabled () {
      return !this.hasApprovalPermission
    },
    isRejectButtonDisabled () {
      return !this.hasApprovalPermission || this.value.trim().length === 0 || this.isOverLength
    },
    isApproveButtonDisabled () {
      return !this.hasApprovalPermission || this.isOverLength
    }
  }
}
</script>
